import { FC, ReactNode } from 'react';
import { Box, FormLabel, OutlinedInput, Typography } from '@mui/material';

import styles from './CustomInput.module.scss';

type CustomInputProps = {
  required?: boolean;
  disabled?: boolean;
  inputType?: 'text' | 'email';
  inputName?: string;
  inputLabel?: string;
  placeholder?: string;
  error?: string;
  value?: string | null | undefined;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  customClass?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
};

const CustomInput: FC<CustomInputProps> = ({
  required = false,
  disabled = false,
  inputType = 'text',
  inputName = '',
  inputLabel = '',
  placeholder,
  value = '',
  error = '',
  onChange,
  onBlur,
  customClass,
  startIcon,
  endIcon,
}) => {
  const inputPlaceholder = placeholder || inputLabel;

  return (
    <Box
      id={styles.customInputContainer}
      className={customClass}
    >
      {inputLabel && (
        <FormLabel className={styles.customInputLabel}>
          <Typography variant="h11Semibold">{inputLabel}</Typography>
        </FormLabel>
      )}

      <Box className={styles.inputWrapper}>
        {startIcon && <Box className={styles.startIcon}>{startIcon}</Box>}

        <OutlinedInput
          type={inputType}
          name={inputName}
          required={required}
          disabled={disabled}
          value={value}
          className={`${!!error.length && styles.error} ${styles.customInput} ${
            startIcon ? styles.withStartIcon : ''
          } ${endIcon ? styles.withEndIcon : ''}`}
          placeholder={inputPlaceholder}
          onChange={onChange}
          onBlur={onBlur}
        />

        {endIcon && <Box className={styles.endIcon}>{endIcon}</Box>}
      </Box>

      {error && (
        <Typography
          variant="h11"
          className={styles.errorMessage}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default CustomInput;
